import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
} from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import { categoryModel } from '@/models/privilege/privilege-category'
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import useTagList from '@/utils/hooks/useTagList'

export default function useCreateSubCategoryModal(props) {
  const vm = getCurrentInstance().proxy
  const {
    createSubCategory,
    getDetailCategory,
    EditSubCategory,
  } = categoryModel()

  const { openDefaultErrorModal, openErrorModal } = useValidationModal()

  const { fetchTagListData } = useTagList()

  const categoryModal = reactive({
    categoryId: 0,
    status: true,
    nameEn: '',
    nameTh: '',
    Reference: '',
    tag: [],
    image: { file: null, url: null },
    imageSub: { file: null, url: null },
  })

  const optionData = reactive({
    tagList: [],
  })

  const onUploadImage = image => {
    categoryModal.image.file = image.file
    categoryModal.image.url = image.url
  }

  const onUploadImageSub = imageSub => {
    categoryModal.imageSub.file = imageSub.file
    categoryModal.imageSub.url = imageSub.url
  }

  const createSubCategoryModal = () => {
    window.$loading(true)
    const payload = {
      Category_Level: 2,
      Parent_Category_Id: props.CategoryId,
      Name_Th: categoryModal.nameTh,
      Name_En: categoryModal.nameEn,
      Category_Image: categoryModal.image.file || '',
      Category_Sub_Image: categoryModal.imageSub.file || '',
      Status: categoryModal.status ? 1 : 2,
      Req_Identity_Id: 1,
      Tag_List:
        categoryModal.tag.length > 0 ? categoryModal.tag.map(o => o.label) : [],
    }

    createSubCategory.payload = payload
    store
      .dispatch('api/apiFormRequest', createSubCategory)
      .then(response => {
        vm.$emit('onSuccessForm')
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const editSubCategoryModal = () => {
    window.$loading(true)
    const payload = {
      Category_Id: props.CategorySubId,
      Name_Th: categoryModal.nameTh,
      Name_En: categoryModal.nameEn,
      Category_Image: categoryModal.image.file || '',
      Category_Sub_Image: categoryModal.imageSub.file || '',
      Status: categoryModal.status ? 1 : 2,
      Req_Identity_Id: 1,
      IsImageChange: !!categoryModal.image.file,
      IsSubImageChange: !!categoryModal.imageSub.file,
      Tag_List:
        categoryModal.tag.length > 0 ? categoryModal.tag.map(o => o.label) : [],
    }

    EditSubCategory.payload = payload
    store
      .dispatch('api/apiFormRequest', EditSubCategory)
      .then(response => {
        vm.$emit('onSuccessForm')
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const onSubmitCategory = () => {
    if (props.CategorySubId) {
      editSubCategoryModal()
    } else {
      createSubCategoryModal()
    }
  }

  const fetchModalSubcategory = () => {
    window.$loading(true)
    getDetailCategory.payload.Category_Id = props.CategorySubId

    store
      .dispatch('api/apiRequest', getDetailCategory)
      .then(response => {
        const respData = response.data.resp
        categoryModal.status = !!respData.status
        categoryModal.Reference = respData.alt_reference
        categoryModal.nameEn = respData.name_en
        categoryModal.nameTh = respData.name_th
        categoryModal.image.url = respData.category_image_url
        categoryModal.imageSub.url = respData.category_sub_image_url
        categoryModal.tag = respData.tag_list.length > 0
          ? respData.tag_list.map((obj, index) => ({
            seq: index,
            label: obj,
          }))
          : []
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const fetchTag = () => {
    optionData.tagList = fetchTagListData()
  }

  onBeforeMount(() => {
    fetchTag()
    categoryModal.categoryId = props.CategoryId
    if (props.CategorySubId) {
      fetchModalSubcategory()
    }
  })

  return {
    categoryModal,
    optionData,
    onUploadImage,
    onUploadImageSub,
    onSubmitCategory,
  }
}
